var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.error)?_c('div',{class:['related-info component', _vm.type]},[_c('div',{staticClass:"box-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"link-list"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05372c62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RelatedInfo/RelatedInfo.vue
// module id = null
// module chunks = 